import { RouteConfig } from "vue-router";

export const RDocumentCard: RouteConfig = {
  path: "",
  name: "DocumentPage",
  component: () =>
    import(
      /* webpackChunkName: "document-card" */
      "./VDocumentCard.vue"
    ),
  meta: {
    label: "documents",
  },
};
